import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Our theme has its own font sizes and colours; tailwind-merge has to know them to merge correctly.
const merge = extendTailwindMerge({
  extend: {
    theme: { text: ['2xs', 'xs', 'sm', 'base', 'lg', 'xl', '2xl'] },
    classGroups: { 'font-size': [{ text: ['2xs', 'xs', 'sm', 'base', 'lg', 'xl', '2xl'] }] },
  },
});

/** Joins class names, later Tailwind classes win over earlier ones. */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
